import type { ExtensionConfig } from '@goto/shell'

const baseUrl = '/experiences/cc-config'

const extensionConfig: ExtensionConfig = {
  id: '@ucc/cc-config/extension',
  url: new URL(`${baseUrl}/extension.js`, location.origin),
  prerequisites: {
    ccFlags: 'cc-config.gtc || engagements',
  },
}

export default extensionConfig
